import {
  BooleanField,
  Datagrid,
  ReferenceField,
  TextField,
  TextInput,
  // SearchInput,
  SelectInput,
  useTranslate,
} from 'react-admin'
import { ListBase } from '../../components/base'
import { NameField, DateField } from '../../components/fields'
import { ADMINS_FIELDS, COMMON_FIELDS } from '../../providers/localization/constant'
import { ActionButton } from '../../components/list-actions'

const AdminList = (): JSX.Element => {
  const translate = useTranslate()
  const adminListFilters = [
    // <SearchInput
    //   key={0}
    //   source='name'
    //   alwaysOn
    //   InputLabelProps={{ shrink: true }}
    //   InputProps={{ notched: false }}
    //   placeholder={translate(`${ADMINS_FIELDS}.searchable`)}
    // />,
    // <SearchInput
    //   key={1}
    //   source='email'
    //   alwaysOn
    //   InputLabelProps={{ shrink: true }}
    //   InputProps={{ notched: false }}
    //   placeholder={translate(`${ADMINS_FIELDS}.email`)}
    // />,
    <TextInput key={0} source='name' alwaysOn label={translate(`${ADMINS_FIELDS}.name`)} />,
    <TextInput key={1} source='email' alwaysOn label={translate(`${ADMINS_FIELDS}.email`)} />,
    <SelectInput
      key={4}
      label={`${COMMON_FIELDS}.status.label`}
      source='is_active'
      choices={[
        { id: 'true', name: `${COMMON_FIELDS}.status.choices.active` },
        { id: 'false', name: `${COMMON_FIELDS}.status.choices.inActive` },
      ]}
    />,
  ]

  return (
    <ListBase perPage={50} filters={adminListFilters} sort={{ field: 'name_th', order: 'ASC' }}>
      <Datagrid rowClick={null} bulkActionButtons={null}>
        <NameField
          firstNameSource='firstname_th'
          lastNameSource='lastname_th'
          source='firstname_th'
          sortBy='name_th'
          label={`${ADMINS_FIELDS}.name`}
        />
        <TextField source='username' label={`${ADMINS_FIELDS}.username`}></TextField>
        <TextField source='email' label={`${ADMINS_FIELDS}.email`}></TextField>
        <ReferenceField
          source='role.id'
          reference='roles'
          label={`${ADMINS_FIELDS}.role`}
          sortBy='role'
        >
          <TextField source='name'></TextField>
        </ReferenceField>
        <DateField
          source='create_at'
          showTime
          label={`${ADMINS_FIELDS}.create_at`}
          textAlign='center'
        />
        <DateField
          source='last_login'
          showTime
          label={`${ADMINS_FIELDS}.last_login`}
          textAlign='center'
        />
        <BooleanField
          source='is_active'
          label={`${COMMON_FIELDS}.status.label`}
          textAlign='center'
        />
        <ActionButton deleteButton={false} />
      </Datagrid>
    </ListBase>
  )
}

export default AdminList
